var _templateObject, _templateObject2;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import styled, { css } from 'styled-components';
import MuiDialog from '@material-ui/core/Dialog';
export var StyledModal = styled(MuiDialog)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "])), theme.palette.text.secondary);
});